import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';

export interface MerchantUserDto {
  id?: string;
  firstName: string;
  lastName: string;
  document: string;
  email: string;
  phone: string;
  gender?: string;
  permissionIds?: string[];
}

export interface SystemActionParamDto {
  id: string;
  role: string;
  text?: string;
}

@Injectable({ providedIn: 'root' })
export class MerchantUsersService {
  private base = `${API_PATH}merchant-users`;

  constructor(private http: HttpClient) {}

  list(): Observable<MerchantUserDto[]> {
    return this.http.get<MerchantUserDto[]>(this.base);
  }

  getMyPermissions(): Observable<SystemActionParamDto[]> {
    return this.http.get<SystemActionParamDto[]>(`${this.base}/my-permissions`);
  }

  create(dto: MerchantUserDto): Observable<MerchantUserDto> {
    return this.http.post<MerchantUserDto>(this.base, dto);
  }

  update(id: string, dto: Partial<MerchantUserDto>): Observable<MerchantUserDto> {
    return this.http.put<MerchantUserDto>(`${this.base}/${id}`, dto);
  }

  remove(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
}
